function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import './PageHeaderActions.css';
import whitelistProps from '../../utils/whitelistProps';
import ThemeContext from '../../ThemeContext/ThemeContext';
var whitelist = whitelistProps();
export default function HeaderActions(_ref) {
  var children = _ref.children,
    attrs = _objectWithoutProperties(_ref, ["children"]);
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "_page-header__actions _page-header__actions--".concat(theme)
  }, whitelist(attrs)), children);
}